// WhyChooseOne component - Converted from components/WhyChooseOne.vue
// Why choose us section with reasons
// Converted: <template> -> JSX, v-for -> map, :src -> src, :style -> style, v-html -> dangerouslySetInnerHTML
// Converted: NuxtLink -> Link
import React from 'react';
import { Link } from 'react-router-dom';
import leafImg from '../assets/images/resources/leaf.png';
import whyChooseImg from '../assets/images/resources/why_choose1_img-1.jpg';

const WhyChooseOne = () => {
  // Converted from Vue: reasons array
  const reasons = [
    {
      id: '01',
      text: 'Innovations technologiques pour l’optimisation des récoltes',
    },
    {
      id: '02',
      text: 'Formation et sensibilisation des agriculteurs sur les pratiques durables',
    },
    {
      id: '03',
      text: 'Développement de systèmes de gestion des ressources en eau',
    },
  ];

  return (
    <section className="why_choose_one">
      <div className="container">
        <div className="row">
          <div className="col-xl-6 col-lg-6">
            <div className="why_choose_one_left_content">
              <div className="block-title text-left">
                <p>POURQUOI NOUS CHOISIR</p>
                <h3 style={{fontSize: '2.5rem',marginTop: '15px'}}>
                Le Leader 
                de l’agriculture 
                
                  moderne
                </h3>
                <div className="leaf">
                  <img src={leafImg} alt="Leaf" />
                </div>
              </div>
              <ul className="why_choose_list list-unstyled">
                {reasons.map((item, index) => (
                  <li key={index}>
                    <div className="choose_count">
                      <h2>{item.id}</h2>
                    </div>
                    <div className="choose_text">
                      <p>{item.text}</p>
                    </div>
                  </li>
                ))}
              </ul>
              <div className="why_choose_btn">
                <Link to="/about" className="thm-btn">
                  Découvrez-en plus
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6">
            <div className="why_choose_image_top">
              <div className="why_choose_image" style={{ backgroundImage: `url(${whyChooseImg})` }}>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseOne;
